import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_TEMPLATE_SCHEMA_DIFF, GET_TEMPLATE_SCHEMA_DIFF_SUCCESS, GET_TEMPLATE_SCHEMA_DIFF_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

/* What this draft changes relative to the published, active template for the same
 * entity type — the backend resolves that counterpart itself, so only the template
 * being inspected is named here. */
function* getTemplateSchemaDiff({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    delete filteredHeaders['X-Requested-By'];

    const { templateId } = payload?.data ?? {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates/${templateId}/schema-diff`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TEMPLATE_SCHEMA_DIFF_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TEMPLATE_SCHEMA_DIFF_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TEMPLATE_SCHEMA_DIFF_ERROR, payload: error });
  }
}

export function* watchGetTemplateSchemaDiff() {
  yield takeEvery(GET_TEMPLATE_SCHEMA_DIFF, getTemplateSchemaDiff);
}

function* getTemplateSchemaDiffSaga() {
  yield all([fork(watchGetTemplateSchemaDiff)]);
}

export default getTemplateSchemaDiffSaga;
